import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SkeletonLoader } from "@widget/loaders";
/**
 * @export
 * Skeleton for a dashboard page — a grid of card/stat/chart placeholders
 * (the `dashboard` fallback).
 *
 * @advanced
 */
export const DashboardSkeleton = () => {
    return _jsxs("div", { style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '1rem',
            padding: '1rem',
            justifyContent: 'space-around'
        }, children: [_jsx(SkeletonLoader, { width: "22%", height: "10rem", additionalStyle: { borderRadius: '0.5rem' } }), _jsx(SkeletonLoader, { width: "22%", height: "10rem", additionalStyle: { borderRadius: '0.5rem' } }), _jsx(SkeletonLoader, { width: "22%", height: "10rem", additionalStyle: { borderRadius: '0.5rem' } }), _jsx(SkeletonLoader, { width: "22%", height: "10rem", additionalStyle: { borderRadius: '0.5rem' } }), _jsx(SkeletonLoader, { width: "72%", height: "20rem", additionalStyle: { borderRadius: '0.5rem' } }), _jsx(SkeletonLoader, { width: "22%", height: "20rem", additionalStyle: { borderRadius: '0.5rem' } }), _jsx(SkeletonLoader, { width: "22%", height: "20rem", additionalStyle: { borderRadius: '0.5rem' } }), _jsx(SkeletonLoader, { width: "72%", height: "20rem", additionalStyle: { borderRadius: '0.5rem' } })] });
};
